<div class="table-scroll-wrapper">
    <table class="table-primary" [formGroup]="formArray">
        <thead>
        <tr>
          <ng-container *ngFor="let column of columns">
            <!-- show header based on the display function execution if provided else always show-->
            <ng-container *ngIf="column.headerDisplayPredicate()">
              <th *ngIf="column.sortable; else notSortable"
                class="sort"
                [class.text-left]="column?.fieldType !== FieldType.Number"
                [class.text-right]="column?.fieldType === FieldType.Number"
                (click)="sortByColumn(column)"
                [ngStyle]="column.style"
                [ngClass]="column.class"
              > {{column.header}}
              <img [class.asc]="tableColumns[column.field]" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
              </th>

              <ng-template #notSortable>
                <th
                  [class.text-left]="column?.fieldType !== FieldType.Number"
                  [class.text-right]="column?.fieldType === FieldType.Number"
                  [ngStyle]="column.style"
                  [ngClass]="column.class">
                  {{column.header}}
                </th>
              </ng-template>
            </ng-container>
          </ng-container>
          <!-- <th class="controls"></th> -->
        </thead>
        <tbody cdk-scrollable [style.min-height]="tableMinHeight" [style.overflow]="isScrollable ? 'overlay' : 'hidden'">
          <tr class="table-row" *ngFor="let control of formArray.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i">
            <ng-container *ngFor="let column of columns">
              <td *ngIf="column.headerDisplayPredicate()"
                [class.text-left]="column?.fieldType !== FieldType.Number"
                [class.text-right]="column?.fieldType === FieldType.Number"
                [ngStyle]="column.style"
                [ngClass]="[column.class ?? '', column?.tdClass ?? '']"
              >
          
              <ng-container [ngSwitch]="column.RowType">
                <div *ngSwitchCase="RowType.Double">
                  <div class="heading"> {{control.value[column.doubleRowField.headingField]}}</div>
                  <div class="secondary">
                    {{control.value[column.doubleRowField.secondaryField1]}} 
                  </div>
                </div>
                <div *ngSwitchCase="RowType.Location" [ngStyle]="column.elementStyle"
                >
                  <app-inventory-locations-dropdown 
                    class="inventory-locations-dropdown"
                    [formControl]="control.controls[column.field]"
                    [excludeOptions]="getLocationsToExcludeWhichAlreadySelectedForTheDropdown(i, column.field)"
                    [positiveInventoryBalanceLocationIDs]="inventoryLocationsService?.getPositiveInventoryBalanceLocationIDs(control.value.drugID)"
                    (optionChosen)="handleChosenLocation($event, i, column)"
                  ></app-inventory-locations-dropdown>
                </div>

                <div *ngSwitchCase="RowType.InputNumber"
                >
                  <app-input class="input-number"
                    [type]="'number'"
                    textAlign="right"
                    [autofocus]="true"
                    [showErrors]="column.showInputErrors"
                    [formControlName]="column.field"
                    (keyupEnter)="handleNumberInputEnter(i)"
                    (keydownTab)="handleNumberInputKeydownTab(i)"
                    #appInput
                  ></app-input>
                </div>

                <div class="back-count" *ngSwitchCase="RowType.BackCount" >
                    <app-yes-no-toggle [hidden]="!column.rowValueDisplayPredicate(control.value)"
                      [control]="control.controls[column.field]"
                    ></app-yes-no-toggle>
                </div>

                <div *ngSwitchCase="RowType.BackCountNotResolvedTooltip" class="relative">
                  <ng-container *ngIf="column.headerDisplayPredicate()">
                    <app-back-count-not-resolved-tooltip class="back-count-not-resolved-tooltip" [hidden]="!column.rowValueDisplayPredicate(control.value)"
                      [locationID]="control.value[column.additionalProps.locationID]"
                      [drugID]="control.value[column.additionalProps.drugID]"
                    ></app-back-count-not-resolved-tooltip>
                  </ng-container>
                </div>
                <!-- pass in unshared item -->
                <div *ngSwitchCase="RowType.Template">
                  <ng-container *ngIf="template">
                    <ng-container *ngTemplateOutlet="template; context: {$implicit: control, index: i}"></ng-container>
                  </ng-container>
                </div>

                <div class="note" *ngSwitchCase="RowType.Note">
                  <app-add-note 
                    class="block relative cursor-pointer z-10"  
                    [friendlyName]="control.value[column.noteRow.noteDrugNameField]"
                    [note]="control.value[column.field]"
                    (deleted)="removeNote(control.controls[column.field])"
                    (submitted)="saveAddedNote($event, control.controls[column.field])">
                  </app-add-note>
                </div>

                <div *ngSwitchCase="RowType.RemoveRowButton" class="remove-btn">
                  <div class="delete-icon" (click)="deleteRow(i)"></div>
                </div>

                <!-- regular text -->
                <ng-container *ngSwitchDefault>
                  <ng-container #regularRaw [ngSwitch]="column.fieldType"> 
                    <container-element *ngSwitchCase="FieldType.DateTime">
                      {{ control.value[column.field] | formattedDate: 'MMM d a, HH:mm yyyy'}}
                    </container-element>
            
                    <container-element *ngSwitchDefault>
                      {{ control.value[column.field] }}
                    </container-element>
                  </ng-container>

                </ng-container>
              </ng-container> 
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
  </div>

  <button class="add-new-ndc" [ngClass]="adNdcClasses" [hidden]="!canAddNewItem"
    (click)="addNdc.emit()" [disabled]="formArray.invalid && !addNewItemAlwaysEnabled"
   >{{addItemWording}}
  </button>
